import React from "react";

export const X: React.FC<{ fill?: "filled" | "none" }> = ({
  fill = "none"
}) => {
  if (fill === "filled") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 256 256"
        width="100%"
        height="100%"
      >
        <path
          fill="currentColor"
          d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM181.66,170.34a8,8,0,0,1-11.32,11.32L128,139.31,85.66,181.66a8,8,0,0,1-11.32-11.32L116.69,128,74.34,85.66A8,8,0,0,1,85.66,74.34L128,116.69l42.34-42.35a8,8,0,0,1,11.32,11.32L139.31,128Z"
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden={true}
    >
      <path
        d="M25.7071 7.70711C26.0976 7.31658 26.0976 6.68342 25.7071 6.29289C25.3166 5.90237 24.6834 5.90237 24.2929 6.29289L16 14.5858L7.70711 6.29289C7.31658 5.90237 6.68342 5.90237 6.29289 6.29289C5.90237 6.68342 5.90237 7.31658 6.29289 7.70711L14.5858 16L6.29289 24.2929C5.90237 24.6834 5.90237 25.3166 6.29289 25.7071C6.68342 26.0976 7.31658 26.0976 7.70711 25.7071L16 17.4142L24.2929 25.7071C24.6834 26.0976 25.3166 26.0976 25.7071 25.7071C26.0976 25.3166 26.0976 24.6834 25.7071 24.2929L17.4142 16L25.7071 7.70711Z"
        fill="currentColor"
      />
    </svg>
  );
};
